import React from "react"


export default function Nav() {
    return (
        <nav className="nav">
            <h2>Veljko's travel journal</h2>
        </nav>
    )
}